import React, { useCallback, useEffect, useState, useRef } from 'react';

import style from './index.scss';
import { useDTAG } from '@theme/js/hooks/useDTAG';

const SCROLL_HEIGHT = 300;

export const BackToTop = () => {
    const scrollToTop = useDTAG('DTAG_SCROLL_TO_TOP', Number);

    const [show, setShow] = useState<boolean>(false);
    const isScrollInProgress = useRef(false);
    const timeout = useRef<number | undefined>(undefined);

    const scrollToTopHandler = (): void => {
        isScrollInProgress.current = true;
        setShow(false);
        // If user prevent scroll, we need to set this value back, otherwise scroll may not display again, until user will scroll to top manually.
        window.clearTimeout(timeout.current);
        timeout.current = window.setTimeout(() => {
            setShow(window.scrollY > SCROLL_HEIGHT);
            isScrollInProgress.current = false;
        }, 1000);
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    const scrollHandler = useCallback(() => {
        if (!isScrollInProgress.current) {
            setShow(window.scrollY > SCROLL_HEIGHT);
        } else if (window.scrollY < SCROLL_HEIGHT) {
            isScrollInProgress.current = false;
        }
    }, []);

    useEffect(() => {
        document.addEventListener('resize', scrollHandler);
        document.addEventListener('scroll', scrollHandler);
        return () => {
            document.removeEventListener('resize', scrollHandler);
            document.removeEventListener('scroll', scrollHandler);
        };
    }, [scrollHandler]);

    if (scrollToTop !== 1) {
        return null;
    }
    return (
        <div className={`${style.backToTopButton} ${show ? style.show : ''}`} onClick={scrollToTopHandler}></div>
    );
};
